import React from "react";
import { PaginationDiv } from "../../style/Table.style";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { IconButton } from "@mui/material";

function Pagination(props) {
  return (
    <PaginationDiv
      style={{
        backgroundColor: "#e6e9f0",
      }}
    >
      <div>
        <span>Go to Page: </span>
        <input
          type="number"
          min="1"
          defaultValue={props.pageIndex + 1}
          onChange={(e) => {
            const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0;
            props.gotoPage(pageNumber);
          }}
          style={{ width: "40px" }}
        />
      </div>

      <div style={{ display: "flex", alignItems: "center" }}>
        <IconButton
          sx={{ color: "#2e68e8" }}
          onClick={() => props.gotoPage(0)}
          disabled={!props.canPreviousPage}
        >
          <SkipPreviousIcon />
        </IconButton>
        <IconButton
          sx={{ color: "#2e68e8" }}
          onClick={() => props.previousPage()}
          disabled={!props.canPreviousPage}
        >
          <KeyboardDoubleArrowLeftIcon />
        </IconButton>
        <div
          style={{
            margin: "0px .4rem",
            color: "#2e68e8",
          }}
        >
          {" "}
          {props.pageIndex + 1}
        </div>

        <IconButton
          sx={{ color: "#2e68e8" }}
          onClick={() => props.nextPage()}
          disabled={!props.canNextPage}
        >
          <KeyboardDoubleArrowRightIcon />
        </IconButton>
        <IconButton
          sx={{ color: "#2e68e8" }}
          onClick={() => props.gotoPage(props.pageCount - 1)}
          disabled={!props.canNextPage}
        >
          <SkipNextIcon />
        </IconButton>
      </div>
    </PaginationDiv>
  );
}

export default Pagination;
